namespace RioERP.Orders {
    export interface OrderShippingRow {
        Id?: number;
        OrderId?: number;
        ShippingProviderId?: number;
        EStatus?: Web.Enums.StatusTypeKey;
        TrackingId?: string;
        TrackingUrl?: string;
        ShippingCost?: number;
        IsActive?: boolean;
        ShippingDate?: string;
        OrderCustomerId?: number;
        OrderOrderNumber?: string;
        OrderCustomerName?: string;
        OrderCustomerEmail1?: string;
        OrderCustomerEmail2?: string;
        OrderCustomerMobile1?: string;
        OrderCustomerMobile2?: string;
        OrderBillingAddress1?: string;
        OrderBillingAddress2?: string;
        OrderBillingCity?: string;
        OrderBillingStateId?: number;
        OrderBillingPincode?: number;
        OrderShippingToName?: string;
        OrderShippingAddress1?: string;
        OrderShippingAddress2?: string;
        OrderShippingCity?: string;
        OrderShippingStateId?: number;
        OrderShippingPincode?: number;
        OrderEOrderStatus?: number;
        OrderEShippingType?: number;
        OrderDiscountPer?: number;
        OrderOrderDate?: string;
        OrderESourceType?: number;
        OrderSourceName?: string;
        OrderEmailSendCount?: number;
        OrderIsEmailSent?: boolean;
        OrderEPaymentStatus?: number;
        OrderLastEmailSentDate?: string;
        OrderFranchiseeId?: number;
        OrderEOrderProcessBy?: number;
        OrderDiscountCoupon?: string;
        OrderDiscountAmount?: number;
        OrderGrossAmount?: number;
        OrderNetAmount?: number;
        OrderTaxableAmount?: number;
        OrderEShippingStatus?: number;
        OrderEInvoiceStatus?: number;
        OrderMailId?: number;
        OrderEPaymentType?: number;
        OrderGstin?: string;
        OrderExpectedShippingDate?: string;
        OrderEInvoiceTo?: number;
        OrderEFranchiseeDiscountType?: number;
        OrderEFranchiseeDiscount?: number;
        OrderFranchiseeDiscountValue?: number;
        OrderFranchiseeDiscountAmount?: number;
        OrderInvoiceCompanyId?: number;
        OrderShippingNote?: string;
        OrderSourceOrderNumber?: string;
        OrderIsActive?: boolean;
        OrderInsertUserId?: number;
        OrderInsertDate?: string;
        OrderUpdateUserId?: number;
        OrderUpdateDate?: string;
        OrderVendorId?: number;
        ShippingProviderShippingProviderName?: string;
        ShippingProviderDescription?: string;
        ShippingProviderBankName?: string;
        ShippingProviderBankAccountNo?: string;
        ShippingProviderBankIfscCode?: string;
        ShippingProviderTrackingUrl?: string;
        ShippingProviderEApiStatus?: number;
        ShippingProviderGstin?: string;
        ShippingProviderPan?: string;
        ShippingProviderGstCertificate?: string;
        ShippingProviderSecret?: string;
        ShippingProviderIsActive?: boolean;
        ShippingProviderInsertUserId?: number;
        ShippingProviderInsertDate?: string;
        ShippingProviderUpdateUserId?: number;
        ShippingProviderUpdateDate?: string;
        ShippingProviderVendorId?: number;
        ShippingProviderEShippingProviderType?: number;
        ShippingProviderIsDefault?: boolean;
        OrdershippingBooks?: OrdershippingBooksRow[];
        OrdershippingPendrives?: OrdershippingPendrivesRow[];
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace OrderShippingRow {
        export const idProperty = 'Id';
        export const nameProperty = 'TrackingId';
        export const localTextPrefix = 'Orders.OrderShipping';
        export const lookupKey = 'Orders.OrderShipping';

        export function getLookup(): Q.Lookup<OrderShippingRow> {
            return Q.getLookup<OrderShippingRow>('Orders.OrderShipping');
        }
        export const deletePermission = 'Orders:OrdersManagement:Modify';
        export const insertPermission = 'Orders:OrdersManagement:Modify';
        export const readPermission = 'Orders:OrdersManagement:View';
        export const updatePermission = 'Orders:OrdersManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            OrderId = "OrderId",
            ShippingProviderId = "ShippingProviderId",
            EStatus = "EStatus",
            TrackingId = "TrackingId",
            TrackingUrl = "TrackingUrl",
            ShippingCost = "ShippingCost",
            IsActive = "IsActive",
            ShippingDate = "ShippingDate",
            OrderCustomerId = "OrderCustomerId",
            OrderOrderNumber = "OrderOrderNumber",
            OrderCustomerName = "OrderCustomerName",
            OrderCustomerEmail1 = "OrderCustomerEmail1",
            OrderCustomerEmail2 = "OrderCustomerEmail2",
            OrderCustomerMobile1 = "OrderCustomerMobile1",
            OrderCustomerMobile2 = "OrderCustomerMobile2",
            OrderBillingAddress1 = "OrderBillingAddress1",
            OrderBillingAddress2 = "OrderBillingAddress2",
            OrderBillingCity = "OrderBillingCity",
            OrderBillingStateId = "OrderBillingStateId",
            OrderBillingPincode = "OrderBillingPincode",
            OrderShippingToName = "OrderShippingToName",
            OrderShippingAddress1 = "OrderShippingAddress1",
            OrderShippingAddress2 = "OrderShippingAddress2",
            OrderShippingCity = "OrderShippingCity",
            OrderShippingStateId = "OrderShippingStateId",
            OrderShippingPincode = "OrderShippingPincode",
            OrderEOrderStatus = "OrderEOrderStatus",
            OrderEShippingType = "OrderEShippingType",
            OrderDiscountPer = "OrderDiscountPer",
            OrderOrderDate = "OrderOrderDate",
            OrderESourceType = "OrderESourceType",
            OrderSourceName = "OrderSourceName",
            OrderEmailSendCount = "OrderEmailSendCount",
            OrderIsEmailSent = "OrderIsEmailSent",
            OrderEPaymentStatus = "OrderEPaymentStatus",
            OrderLastEmailSentDate = "OrderLastEmailSentDate",
            OrderFranchiseeId = "OrderFranchiseeId",
            OrderEOrderProcessBy = "OrderEOrderProcessBy",
            OrderDiscountCoupon = "OrderDiscountCoupon",
            OrderDiscountAmount = "OrderDiscountAmount",
            OrderGrossAmount = "OrderGrossAmount",
            OrderNetAmount = "OrderNetAmount",
            OrderTaxableAmount = "OrderTaxableAmount",
            OrderEShippingStatus = "OrderEShippingStatus",
            OrderEInvoiceStatus = "OrderEInvoiceStatus",
            OrderMailId = "OrderMailId",
            OrderEPaymentType = "OrderEPaymentType",
            OrderGstin = "OrderGstin",
            OrderExpectedShippingDate = "OrderExpectedShippingDate",
            OrderEInvoiceTo = "OrderEInvoiceTo",
            OrderEFranchiseeDiscountType = "OrderEFranchiseeDiscountType",
            OrderEFranchiseeDiscount = "OrderEFranchiseeDiscount",
            OrderFranchiseeDiscountValue = "OrderFranchiseeDiscountValue",
            OrderFranchiseeDiscountAmount = "OrderFranchiseeDiscountAmount",
            OrderInvoiceCompanyId = "OrderInvoiceCompanyId",
            OrderShippingNote = "OrderShippingNote",
            OrderSourceOrderNumber = "OrderSourceOrderNumber",
            OrderIsActive = "OrderIsActive",
            OrderInsertUserId = "OrderInsertUserId",
            OrderInsertDate = "OrderInsertDate",
            OrderUpdateUserId = "OrderUpdateUserId",
            OrderUpdateDate = "OrderUpdateDate",
            OrderVendorId = "OrderVendorId",
            ShippingProviderShippingProviderName = "ShippingProviderShippingProviderName",
            ShippingProviderDescription = "ShippingProviderDescription",
            ShippingProviderBankName = "ShippingProviderBankName",
            ShippingProviderBankAccountNo = "ShippingProviderBankAccountNo",
            ShippingProviderBankIfscCode = "ShippingProviderBankIfscCode",
            ShippingProviderTrackingUrl = "ShippingProviderTrackingUrl",
            ShippingProviderEApiStatus = "ShippingProviderEApiStatus",
            ShippingProviderGstin = "ShippingProviderGstin",
            ShippingProviderPan = "ShippingProviderPan",
            ShippingProviderGstCertificate = "ShippingProviderGstCertificate",
            ShippingProviderSecret = "ShippingProviderSecret",
            ShippingProviderIsActive = "ShippingProviderIsActive",
            ShippingProviderInsertUserId = "ShippingProviderInsertUserId",
            ShippingProviderInsertDate = "ShippingProviderInsertDate",
            ShippingProviderUpdateUserId = "ShippingProviderUpdateUserId",
            ShippingProviderUpdateDate = "ShippingProviderUpdateDate",
            ShippingProviderVendorId = "ShippingProviderVendorId",
            ShippingProviderEShippingProviderType = "ShippingProviderEShippingProviderType",
            ShippingProviderIsDefault = "ShippingProviderIsDefault",
            OrdershippingBooks = "OrdershippingBooks",
            OrdershippingPendrives = "OrdershippingPendrives",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
